export const DASHBOARD_SOURCE = 'cameras-dashboard';
export const DETAILS_SOURCE = 'details-page';

export const CAMERA_STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export const TV_DISPLAY_MODE = {
  WELCOME: 'WELCOME',
  DEFAULT: 'DEFAULT',
} as const;
